module.exports = __webpack_public_path__ + "./favicons/favicon-32x32.png";